(() => {
  if (window.__ohCrispCartDrawerLoaded) return;
  window.__ohCrispCartDrawerLoaded = true;

  const drawer = document.querySelector('cart-drawer');
  const configElement = document.querySelector('#OhCrispCartDrawerConfig');
  if (!drawer || !configElement) return;

  const template = document.querySelector('#OhCrispCartRecommendations');
  drawer.classList.add('ohc-cart-drawer');

  const config = {
    threshold: Math.max(0, Number(configElement.dataset.freeShippingThreshold) || 3900),
    currency: configElement.dataset.currency || window.Shopify?.currency?.active || 'USD',
    emptyTitle: configElement.dataset.emptyTitle || 'Your snack drawer is empty.',
    emptyCopy: configElement.dataset.emptyCopy || 'Pick a favorite and start crunching.',
    emptyCtaLabel: configElement.dataset.emptyCtaLabel || 'Shop all snacks',
    emptyCtaUrl: configElement.dataset.emptyCtaUrl || '/pages/shopall',
    cartTitle: configElement.dataset.cartTitle || 'Your Crunch Cart',
    recommendationsTitle: configElement.dataset.recommendationsTitle || 'Popular crunches',
    checkoutLabel: configElement.dataset.checkoutLabel || 'Secure checkout',
    bannerText: '',
    bannerBackground: '#7c6bd6',
    bannerTextColor: '#ffffff',
  };

  let refreshTimer = 0;
  let fetching = false;
  let queued = false;
  let lastCart = null;

  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: config.currency,
    maximumFractionDigits: 2,
  });

  const formatMoney = (cents) => moneyFormatter.format(Math.max(0, Number(cents) || 0) / 100);

  const setText = (element, value) => {
    if (element && element.textContent.trim() !== value) element.textContent = value;
  };

  const syncEditorConfig = () => {
    const editorConfig = document.querySelector('#OhCrispCartDrawerEditorConfig');
    if (!editorConfig) return;

    config.bannerText = editorConfig.dataset.bannerText?.trim() || '';
    config.bannerBackground = editorConfig.dataset.bannerBackground || '#7c6bd6';
    config.bannerTextColor = editorConfig.dataset.bannerTextColor || '#ffffff';
    config.checkoutLabel = editorConfig.dataset.checkoutLabel?.trim() || 'Secure checkout';
  };

  const ensureEmptyState = () => {
    const emptyContent = drawer.querySelector('.cart-drawer__empty-content');
    const emptyTitle = drawer.querySelector('.cart__empty-text');
    if (!emptyContent || !emptyTitle) return;

    setText(emptyTitle, config.emptyTitle);

    let emptyCopy = emptyContent.querySelector('.ohc-cart-empty-copy');
    if (!emptyCopy) {
      emptyCopy = document.createElement('p');
      emptyCopy.className = 'ohc-cart-empty-copy';
      emptyTitle.insertAdjacentElement('afterend', emptyCopy);
    }
    setText(emptyCopy, config.emptyCopy);

    const continueButton = Array.from(emptyContent.querySelectorAll('a.button')).find(
      (button) => !button.closest('.ohc-cart-recommendations')
    );
    setText(continueButton, config.emptyCtaLabel);
    if (continueButton) continueButton.href = config.emptyCtaUrl;

    if (!drawer.querySelector('[data-ohc-cart-recommendations]') && template?.content) {
      const recommendations = template.content.cloneNode(true);
      const title = recommendations.querySelector('.ohc-cart-recommendations__title');
      setText(title, config.recommendationsTitle);

      const warnings = drawer.querySelector('.cart-drawer__warnings');
      if (warnings && recommendations.childElementCount) warnings.append(recommendations);
    }
  };

  const ensureShippingProgress = (cart) => {
    const header = drawer.querySelector('.drawer__header');
    const items = drawer.querySelector('cart-drawer-items');
    if (!header || !items || !cart || cart.item_count < 1 || config.threshold < 1) {
      drawer.querySelector('.ohc-cart-shipping')?.remove();
      return;
    }

    let progress = drawer.querySelector('.ohc-cart-shipping');
    if (!progress) {
      progress = document.createElement('section');
      progress.className = 'ohc-cart-shipping';
      progress.setAttribute('aria-label', 'Free shipping progress');
      progress.innerHTML = `
        <p class="ohc-cart-shipping__message" aria-live="polite"></p>
        <div
          class="ohc-cart-shipping__track"
          role="progressbar"
          aria-label="Progress toward free shipping"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <span class="ohc-cart-shipping__fill"></span>
        </div>
      `;
      header.insertAdjacentElement('afterend', progress);
    }

    const complete = cart.total_price >= config.threshold;
    const percentage = Math.min(100, Math.round((cart.total_price / config.threshold) * 100));
    const remaining = Math.max(0, config.threshold - cart.total_price);
    const message = complete
      ? '<strong>Free shipping unlocked!</strong> Your crunch is ready to travel.'
      : `You’re <strong>${formatMoney(remaining)}</strong> away from free U.S. shipping.`;

    progress.classList.toggle('is-complete', complete);
    progress.style.setProperty('--ohc-cart-progress', `${percentage}%`);

    const messageElement = progress.querySelector('.ohc-cart-shipping__message');
    if (messageElement && messageElement.innerHTML !== message) messageElement.innerHTML = message;

    const track = progress.querySelector('.ohc-cart-shipping__track');
    track?.setAttribute('aria-valuenow', String(percentage));
    track?.setAttribute('aria-valuetext', complete ? 'Free shipping unlocked' : `${percentage}% complete`);
  };

  const ensureOfferBanner = (cart) => {
    const items = drawer.querySelector('cart-drawer-items');
    if (!items || !cart || cart.item_count < 1 || !config.bannerText) {
      drawer.querySelector('[data-ohc-cart-offer]')?.remove();
      return;
    }

    let banner = drawer.querySelector('[data-ohc-cart-offer]');
    if (!banner) {
      banner = document.createElement('aside');
      banner.className = 'ohc-cart-offer';
      banner.dataset.ohcCartOffer = '';
      items.insertAdjacentElement('beforebegin', banner);
    }

    setText(banner, config.bannerText);
    banner.style.setProperty('--ohc-cart-offer-background', config.bannerBackground);
    banner.style.setProperty('--ohc-cart-offer-text', config.bannerTextColor);
  };

  const ensureSavingsSummary = (cart) => {
    const totals = drawer.querySelector('.drawer__footer .totals');
    const currentTotal = totals?.querySelector('.totals__total-value');
    if (!totals || !currentTotal || !cart) return;

    let values = totals.querySelector('.ohc-cart-totals__values');
    if (!values) {
      values = document.createElement('div');
      values.className = 'ohc-cart-totals__values';
      currentTotal.insertAdjacentElement('beforebegin', values);
      values.append(currentTotal);
    }

    let savings = values.querySelector('.ohc-cart-savings');
    let compareTotal = values.querySelector('.ohc-cart-compare-total');
    const originalTotal = Math.max(
      Number(cart.original_total_price) || 0,
      (Number(cart.total_price) || 0) + (Number(cart.total_discount) || 0)
    );
    const finalTotal = Number(cart.total_price) || 0;
    const savedAmount = Math.max(0, originalTotal - finalTotal);

    if (originalTotal > 0 && savedAmount > 0) {
      const discountPercent = Math.max(1, Math.round((savedAmount / originalTotal) * 100));

      if (!savings) {
        savings = document.createElement('span');
        savings.className = 'ohc-cart-savings';
        currentTotal.insertAdjacentElement('beforebegin', savings);
      }
      setText(savings, `${discountPercent}% off`);

      if (!compareTotal) {
        compareTotal = document.createElement('s');
        compareTotal.className = 'ohc-cart-compare-total';
        currentTotal.insertAdjacentElement('beforebegin', compareTotal);
      }
      setText(compareTotal, formatMoney(originalTotal));
    } else {
      savings?.remove();
      compareTotal?.remove();
    }
  };

  const ensureTrustRow = (cart) => {
    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    const ctas = checkout?.closest('.cart__ctas');
    const trustTemplate = document.querySelector('#OhCrispCartTrustTemplate');
    const templateMarkup = trustTemplate?.innerHTML.trim() || '';
    const existing = drawer.querySelector('[data-ohc-cart-trust]');

    if (!ctas || !cart || cart.item_count < 1 || !templateMarkup) {
      existing?.remove();
      return;
    }

    if (existing && existing.__ohcTemplateMarkup === templateMarkup) return;

    const fragment = trustTemplate.content.cloneNode(true);
    const trust = fragment.querySelector('[data-ohc-cart-trust]');
    if (!trust || !trust.children.length) {
      existing?.remove();
      return;
    }

    trust.__ohcTemplateMarkup = templateMarkup;
    existing?.remove();
    ctas.insertAdjacentElement('afterend', trust);
  };

  const ensureFilledState = (cart) => {
    const heading = drawer.querySelector('.drawer__heading');
    if (heading && cart) setText(heading, `${config.cartTitle} (${cart.item_count})`);

    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    setText(checkout, config.checkoutLabel);

    ensureShippingProgress(cart);
    ensureOfferBanner(cart);
    ensureSavingsSummary(cart);
    ensureTrustRow(cart);
  };

  const enhance = (cart = lastCart) => {
    syncEditorConfig();

    if (drawer.classList.contains('is-empty') || cart?.item_count === 0) {
      drawer.querySelector('.ohc-cart-shipping')?.remove();
      drawer.querySelector('[data-ohc-cart-offer]')?.remove();
      drawer.querySelector('[data-ohc-cart-trust]')?.remove();
      ensureEmptyState();
      return;
    }

    ensureFilledState(cart);
  };

  const fetchCart = async () => {
    if (fetching) {
      queued = true;
      return;
    }

    fetching = true;
    try {
      const cartUrl = `${window.routes?.cart_url || '/cart'}.js`;
      const response = await fetch(cartUrl, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);
      lastCart = await response.json();
      enhance(lastCart);
    } catch (error) {
      enhance();
      console.warn('[OhCrisp cart drawer]', error);
    } finally {
      fetching = false;
      if (queued) {
        queued = false;
        scheduleRefresh(40);
      }
    }
  };

  const scheduleRefresh = (delay = 80) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(fetchCart, delay);
  };

  const observer = new MutationObserver((mutations) => {
    const meaningfulChange = mutations.some(
      (mutation) =>
        mutation.type === 'childList' ||
        (mutation.type === 'attributes' && mutation.attributeName === 'class')
    );
    if (meaningfulChange) scheduleRefresh();
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh(30));
  }

  document.addEventListener('shopify:section:load', () => {
    syncEditorConfig();
    scheduleRefresh(30);
  });
  enhance();
  if (drawer.classList.contains('active')) scheduleRefresh(0);
})();
